import * as React from "react";
import RouteSys from "./routes/RouteSys";

export default function App() {
  React.useEffect(() => {
    // Check if we are embedded in WordPress iframe
    const params = new URLSearchParams(window.location.search);
    const isEmbed = params.get("embed") === "1";

    if (isEmbed) {
      // Hide header/footer when embedded
      const style = document.createElement("style");
      style.innerHTML = "header, footer, .site-header, .site-footer { display: none !important; }";
      document.head.appendChild(style);
    }

    // Listen for WordPress JWT via postMessage
    function handleWpAuth(event) {
      // Only accept from tvadi.com
      var allowed = ["https://tvadi.com", "https://www.tvadi.com", window.location.origin];
      if (allowed.indexOf(event.origin) === -1) return;

      var data = event.data;
      if (!data) return;
      // Handle WP logout — clear stale session
      if (data.type === "wp_auth_logout") {
        sessionStorage.removeItem("userDetails");
        localStorage.removeItem("token");
        console.log("WP logout: session cleared");
        window.dispatchEvent(new Event("tvadi-auth-update"));
        return;
      }
      if (data.type !== "wp_auth_jwt") return;

      var token = data.token;
      if (!token) return;

      console.log("Received WP JWT, verifying...");

      // Verify JWT with our backend and get app token
      fetch(process.env.REACT_APP_API_URL + "/wp-auth/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token })
      })
        .then(function(res) { return res.json(); })
        .then(function(result) {
          if (result.status && result.token) {
            // Store in same format the rest of the app expects
            var userDetails = {
              status: true,
              message: "Login Successfully.",
              token: result.token,
              errorMessage: "Success",
              role: result.user.role,
              username: result.user.username,
              user_id: result.user._id,
              email: result.user.email,
              wp_user_id: result.user.wp_user_id,
              display_name: result.user.display_name
            };
            localStorage.setItem("token", result.token);
            sessionStorage.setItem("userDetails", JSON.stringify(userDetails));
            console.log("WP auth success:", result.user.username);

            // Notify parent window (WordPress) that auth succeeded
            if (window.parent !== window) {
              window.parent.postMessage({ type: "tvadi_auth_success", username: result.user.username }, "https://tvadi.com");
            }

            // Dispatch event so React components can react
            window.dispatchEvent(new Event("tvadi-auth-update"));
          } else {
            console.error("WP JWT verification failed:", result.error);
          }
        })
        .catch(function(err) {
          console.error("WP auth error:", err);
        });
    }

    window.addEventListener("message", handleWpAuth);

    // Send ready message to parent so WordPress knows iframe is loaded
    if (window.parent !== window) {
      window.parent.postMessage({ type: "tvadi_iframe_ready" }, "https://tvadi.com");
    }

    return function() {
      window.removeEventListener("message", handleWpAuth);
    };
  }, []);

  return (
    <>
      <RouteSys />
    </>
  );
}
